import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AlliancesService } from '@services/alliances.service';
import { UrlService } from '@services/url.service';
import { selectContextCore } from '@store/context/context.selector';
import { IHotelsAppState } from '@store/index';
import { getNested } from 'globals';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'am-recommended-hotels',
  styleUrls: ['./recommended-hotels.component.scss'],
  templateUrl: './recommended-hotels.component.html',
})
export class RecommendedHotelsComponent implements OnInit, OnDestroy {
  @Input()
  public hotels: any;
  @Input()
  public reference: any;
  @Input()
  public query: any;
  @Input()
  public isLanding: boolean;
  @Input()
  public isMobile = false;

  public resizedUrl: string;
  public isAlliance: boolean;
  public superclubPrice: number;
  public brand: string;
  private brands: Array<string> = ['avantrip'];
  private unSubscribe$ = new Subject<void>();

  constructor(
    private urlService: UrlService,
    private allianceService: AlliancesService,
    private storeContext$: Store<IHotelsAppState>,
  ) {
    this.storeContext$
      .pipe(select(selectContextCore), takeUntil(this.unSubscribe$))
      .subscribe((context) => {
        if (this.brands.includes(context.brand)) {
          this.brand = context.brand;
        } else {
          this.brand = 'almundo';
        }
      });
  }

  public ngOnInit() {
    this.resizedUrl = this.urlService.getResizedUrl();
    this.isAlliance = this.allianceService.isAlliance();
  }

  public getTaxes(hotel: any) {
    if (this.query.queryParams.withFullPrice === 'false') {
      return hotel.rate && hotel.rate.price ? hotel.rate.price.included_taxes : false;
    } else {
      return true;
    }
  }

  public setTaxes(hotel: any) {
    if (!(this.query.queryParams.withFullPrice === 'false')) {
      if (!this.isLanding) {
        return hotel.rate.price.price_per_night_per_room_with_service_fee;
      } else {
        return hotel.rate.price.show_amount_per_night_per_room;
      }
    } else {
      if (!this.isLanding) {
        return hotel.rate.price.per_night_per_room;
      } else {
        return hotel.rate.price.show_amount_per_night_per_room;
      }
    }
  }

  public setTaxesTotal(hotel: any) {
    if (!(this.query.queryParams.withFullPrice === 'false')) {
      if (!this.isLanding) {
        return hotel.rate.price.total_with_service_fee;
      } else {
        return hotel.rate.price.show_amount;
      }
    } else {
      if (!this.isLanding) {
        return hotel.rate.price.total;
      } else {
        return hotel.rate.price.show_amount_per_night_per_room;
      }
    }
  }

  public getHotelImage(images: any): string {
    if (images && images.length > 0) {
      return this.resizedUrl + images[0].url.replace('st.images', 'images');
    } else {
      return `assets/images/${this.brand}-hotel-no-image.svg`;
    }
  }

  public getSuperClubPrice(hotel: any) {
    if (!!getNested(hotel, 'rate', 'price')) {
      return Math.ceil(
        this.query?.queryParams?.priceBy === 'TOTAL'
          ? hotel.rate.price.total
          : hotel.rate.price.per_night_per_room,
      );
    }
  }

  public detailRedirect(hotel) {
    const redirection = this.urlService.getDetailRedirection(hotel);
    window.open(redirection.url, redirection.self ? '_self' : '_blank');
  }

  public ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
